import React, { useEffect } from "react";
import { trackPageView, getSessionId, getUserId } from "../utils/pageTracking";
import { useImages } from "../hooks/useImages";

const GUIDS = {
  picture1: '0445a595-2fff-4916-85ba-91cb68c39301',
  picture2: 'd0af25e8-d93f-4933-b9e6-019cd92b0c54',
  picture3: '4dfed945-8301-4a95-8948-f2f0786cf9c8',
  picture4: '2a486158-cdd9-429a-85a4-e3d60d6d970d',
  picture5: 'd87b8c66-85a1-4f41-8d57-a907a5a1a756',
  picture6: '28458528-72da-4446-bc3d-ce9d48344124'
}

const WhatIsComposting: React.FC = () => {
  useEffect(() => {
    // Track page view
    trackPageView('WhatIsComposting', getSessionId(), getUserId());

    // Scroll to top when page loads
    window.scrollTo(0, 0);
  }, []);

  const fullWidthImage = useImages(GUIDS.picture1)?.image;
  const leftColumn = [useImages(GUIDS.picture2)?.image, useImages(GUIDS.picture4)?.image, useImages(GUIDS.picture6)?.image];
  const rightColumn = [useImages(GUIDS.picture3)?.image, useImages(GUIDS.picture5)?.image];

  return (
    <div className="bg-[#e7f3e4] min-h-screen pt-24 px-4 py-12">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-xl shadow-md max-w-xl mx-auto p-6 mb-12">
          <h1 className="text-4xl font-bold text-center text-gray-800">What is Composting?</h1>
        </div>

        {/* Full-width image */}
        <img
          src={fullWidthImage}
          alt="Composting main visual"
          className="w-full rounded-xl shadow-lg mb-16"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12">
          {/* Left column */}
          <div className="space-y-16">
            {leftColumn.map((filename, idx) => (
              <img
                key={idx}
                src={filename}
                alt={`Composting left ${idx + 1}`}
                className="w-full rounded-xl shadow-md"
              />
            ))}
          </div>

          {/* Right column */}
          <div className="space-y-16">
            {rightColumn.map((filename, idx) => (
              <img
                key={idx}
                src={filename}
                alt={`Composting right ${idx + 1}`}
                className="w-full rounded-xl shadow-md"
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatIsComposting;
